import { DASHCOLORS } from 'bd-web-components'
import { GRAY_SCALE_06 } from 'bd-web-components/src/utils/dash-colors'
import styled from 'styled-components'

export const ContainerCard = styled.div`
  display: flex;
  border-radius: 10px;
  background: #fff;
  box-shadow: none;
  border: 1px solid ${GRAY_SCALE_06};
      height: 80px;
    background: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0 10px;
    width: 100%;
    max-width: unset;
`

export const MainContainer = styled.div`
  max-width: 250px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
  padding-right: 8px;
  width: 100%;
  height: 100%;
  max-width: unset;
  gap: 0;

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    width: 100%;
    height: 100%;
    max-width: unset;
    padding-left: 8px;
    padding-right: 8px;
    gap: 0;
  }
`

export const IconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  @media (max-width: 768px) {
    margin-right: 10px;
    display: none;
  }
`

export const ContainerValue = styled.div`
  /* max-width: 250px; */
  width: 100%;
  justify-content: space-between;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  /* margin-top: 35px; */

  @media (max-width: 768px) {
    /* flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    padding: 0px 5px;
    width: 100%;
    max-width: unset;
    gap: 8px; */
  }
`

export const ValueText = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${DASHCOLORS.PRIMARY_BLUE_03};
  line-height: 130%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 700px) {
    font-size: 16px !important;
    margin: 0;
    padding: 0;
  }
`

export const DescriptionText = styled.p`
  font-size: 20px;
  line-height: 130%;
  color: ${DASHCOLORS.PRIMARY_BLUE_03};

  @media (max-width: 700px) {
    font-size: 18px;
    margin: 0;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    order: -1;
  }
`
